import { Injectable } from '@angular/core';
import { LoginFormValidate } from '@com-delta-idp/mnx-login-ui';
import { finalize, takeUntil } from 'rxjs/operators';
import {
  DEFAULT_MODAL_ERROR_CODE,
  HOME_PAGE_URL,
  STANDALONE_PAGE_URL
} from '../../constants/login-constant';
import { SaveEmailAddressResponse } from '../../models/add-email-address.interface';
import { LoginModalContent } from '../../models/aem';
import { AddEmailAddressHelperFacadeService } from './add-email-address-helper-facade.service';

@Injectable({
  providedIn: 'root'
})
export class AddEmailAddressFacadeService extends AddEmailAddressHelperFacadeService {
  aemContent!: LoginModalContent;
  constructor() {
    super();
    this.getAddEmailAddressPageContent();
  }

  getAddEmailAddressPageContent(): void {
    this.aemContentService
      .getAEMContent()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.aemContent = response;
        const content = this.addEmailAddressAdapter.getAddEmailAddressContent(
          this.aemContent
        );
        this.addEmailAddressContent$.next(content);
      });
  }

  onFormSubmit(): boolean | void {
    if (this.validateForm()) {
      return false;
    }
    this.disableActionButton(true);
    const requestObject = this.addEmailAddressAdapter.buildRequestObject(
      this.getAddEmailAddressContent()
    );

    this.apiService
      .saveEmailAddress(
        requestObject,
        this.loginAuthFacade.authenticationConfig.TOKEN_HEADER || false,
        this.loginHelperUtils.tokenResponse
      )
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => this.disableActionButton(false))
      )
      .subscribe(
        (response) => {
          if (response?.errors && response?.errors.length > 0) {
            this.handleError(response.errors);
          } else {
            this.handleSuccess(response);
          }
        },
        (error) => this.handleError(error?.error?.errors)
      );
  }

  checkRedirectToAddSQA(response: SaveEmailAddressResponse): boolean {
    return (
      response?.hasSQA === false &&
      !this.loginAuthFacade.authenticationConfig.DISABLE_SQA_SCREEN
    );
  }

  handleSuccess(response: SaveEmailAddressResponse): void {
    this.resetForm();
    if (this.checkRedirectToAddSQA(response)) {
      this.redirectToAddSQA();
    } else if (
      response.formNameSubmitted ===
      STANDALONE_PAGE_URL[this.viewName.LOGIN_CREDENTIALS_SCREEN]
    ) {
      if (response.isLoggedIn) {
        this.coreUtilService.setCookieName(
          'accountType',
          'true-false',
          0,
          true
        );
      }
      this.redirectToHomepage(response);
    } else {
      this.handleError([{ code: DEFAULT_MODAL_ERROR_CODE, description: '' }]);
    }
  }

  redirectToHomepage(response: SaveEmailAddressResponse): void {
    window.location.href = response?.refreshURL || HOME_PAGE_URL;
  }

  redirectToAddSQA(): void {
    const addSQAView = this.viewName.ADD_SECURITY_QUESTION_ANS_SCREEN;
    this.addSqaFacadeService.getAddSqaPageContent();
    if (!this.loginAuthFacade.standalonePage) {
      this.nextDisplayViewService.nextDisplayView(addSQAView);
    } else {
      this.router.navigateByUrl(`/${STANDALONE_PAGE_URL[addSQAView]}`);
    }
  }

  validateForm(): boolean {
    LoginFormValidate.touchControlsAddEmailAddressOnSubmit(
      this.getAddEmailAddressContent()
    );
    this.getAddEmailAddressContent().formAttributes.submitAttempt = true;
    const errorCount = LoginFormValidate.validateFormFields(
      this.getAddEmailAddressContent().formGroup
    );
    this.getAddEmailAddressContent().formAttributes.errorCount = errorCount;
    this.getAddEmailAddressContent().formAttributes.errorAlertBanner =
      LoginFormValidate.getErrorAlert(
        this.getAddEmailAddressContent().formGroup
      );
    return errorCount > 0;
  }
}
